module.exports = __webpack_public_path__ + "img/wishlist.0d84d8c4.svg";